module.exports = __webpack_public_path__ + "static/media/DSC01584.c37f5954.jpeg";